"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ProgramDescriptionContainer = void 0;
var React = _interopRequireWildcard(require("react"));
var _program = require("../../types/program");
var _ProgramDescription = require("../../components/ProgramDescription");
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
const ProgramDescriptionContainer = _ref => {
  let {
    description
  } = _ref;
  if (!description.length) {
    return null;
  }
  return /*#__PURE__*/React.createElement(React.Fragment, null, description.map((item, index) => {
    const elements = index !== 0 ? [/*#__PURE__*/React.createElement("br", {
      key: `break-${index}`
    })] : [];
    switch (item.type) {
      case _program.EDescriptionType.LIST:
        elements.push( /*#__PURE__*/React.createElement(_ProgramDescription.ListDescription, {
          list: item.value,
          key: index,
          text: item.text
        }));
        break;
      case _program.EDescriptionType.PARAGRAPH:
        elements.push( /*#__PURE__*/React.createElement(_ProgramDescription.ParagraphDescription, {
          text: item.value,
          key: index
        }));
    }
    return elements;
  }));
};
exports.ProgramDescriptionContainer = ProgramDescriptionContainer;